import {useCallback} from 'react'
import {getRecaptchaToken} from 'src/common/helpers/recaptchaLoader'
import {useGetConfig} from './useGetConfig'

export function useRecaptcha() {
  const config = useGetConfig()
  const siteKey = config.GOOGLE_RECAPTCHA_SITE_KEY

  const execute = useCallback(
    async (action: string) => {
      if (!siteKey) {
        console.warn('reCAPTCHA site key is not configured')
        return null
      }

      return getRecaptchaToken(siteKey, action) // returns string | null
    },
    [siteKey],
  )

  return {execute}
}
